import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginpageComponent } from './loginpage/loginpage.component';
import { DevOpsOutageFormComponent } from './devopsoutageform/dev-ops-outage-form.component';
import { DevopsreleasenotesComponent } from './devopsreleasenotes/devopsreleasenotes.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NavbarService } from './navbar.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';

// export function msalinstancefactory(): IPublicClientApplication {
//   return new PublicClientApplication({
//     auth: {
//       clientId: '5743f99f-8a3f-4de1-b51c-4a2d065edd02',
//       redirectUri: 'http://localhost:4200/devopsoutageform/',
//     },
//   });
// }

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1; // Remove this line to use Angular Universal

export function MSALInstanceFactory(): IPublicClientApplication {
  // console.log("*********** MSALInstanceFactory this is url", environment.staticLogoutRedirectUrl);
  // console.log("*********** MSALInstanceFactory this is window env", window['__env']);

  return new PublicClientApplication({
    auth: {
      clientId: '8666387d-18d3-4a11-a27a-51f9ec4a5b61',
      authority:'https://login.microsoftonline.com/fb17b3c8-7f83-4132-b2f8-9d236bda120f/',

      redirectUri: 'https://maisteringdevops.maistering.com/devopsoutageform/',
      postLogoutRedirectUri:'https://maisteringdevops.maistering.com/'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  // console.log("*********** MSALInstanceFactory this is env", environment);
  // console.log("*********** MSALInstanceFactory this is window env", window['__env']);
  // protectedResourceMap.set(environment.protectedResourceMap, ['user.read', environment.MCScopes[0]]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  // console.log("*********** MSALInstanceFactory this is window env", window['__env']);

  // console.log("*********** MSALInstanceFactory this is env"+environment);
  return {
    interactionType: InteractionType.Redirect,
    loginFailedRoute: 'https://maisteringdevops.maistering.com/'
  };
}

@NgModule({
  declarations: [
    AppComponent,
    LoginpageComponent,
    DevOpsOutageFormComponent,
    DevopsreleasenotesComponent,
    NavbarComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    MsalModule,
  ],
  providers: [
    NavbarService,
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    MsalService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
